'use client'

import Stick from 'react-stickynode'
import './index.css'

export default function HeaderSticky({
  children,
  sticky = true,
}: {
  children: React.ReactNode
  sticky?: boolean
}) {
  return (
    <Stick
      enabled={sticky}
      innerZ={50}
      className='z-50'
      innerActiveClass='header-sticky'
    >
      {children}
    </Stick>
  )
}
